import {Link, LinkProps, To} from "react-router-dom";

export function OptionalLink(props: { to: To | undefined } & Omit<LinkProps, "to">) {
    if (props.to) {
        return <Link {...props} to={props.to} />
    } else {
        return <>{props.children}</>;
    }
}